// extracted by mini-css-extract-plugin
module.exports = {"table":"missions_table__3yMYH","head":"missions_head__1MLcv"};